import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Download } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function LegalLayout({ title, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black min-h-screen" data-testid="legal-page">
      <Navbar />
      <main id="main-content" tabIndex={-1} className="max-w-[860px] mx-auto px-6 lg:px-10 pt-36 pb-24">
        <Link to="/" className="text-xs uppercase tracking-widest text-fog hover:text-paper transition-colors" data-testid="legal-back">
          &larr; Back to home
        </Link>
        <div className="mt-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <h1 className="font-display text-4xl sm:text-6xl tracking-tighter text-paper">{title}</h1>
          <a
            href="/Aliwer_Legal_Privacy_Terms.pdf"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="legal-download-pdf"
            className="group inline-flex items-center gap-2 rounded-full border border-white/20 text-paper text-sm font-medium px-5 py-2.5 hover:bg-white/5 transition-colors shrink-0"
          >
            <Download size={15} />
            Download PDF (Privacy & Terms)
          </a>
        </div>
        <p className="mt-4 text-sm text-fog">Last updated: {updated}</p>
        <div className="mt-6 rounded-xl border border-white/10 bg-surface p-4 text-xs text-fog leading-relaxed">
          This page summarizes our practices in plain language. For questions, or to exercise
          your rights, contact <span className="text-paper">legal@aliwers.com</span>.
        </div>
        <div className="mt-10 space-y-8">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl sm:text-2xl tracking-tight text-paper">
        <span className="text-fog mr-3 tabular-nums">{n}</span>
        {title}
      </h2>
      <div className="mt-3 text-sm text-fog leading-relaxed space-y-3">{children}</div>
    </section>
  );
}
